import React from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import B2BHeader from "../../components/b2b/B2BHeader";

interface EmployerLayoutProps {
  children: React.ReactNode;
}

const EmployerLayout: React.FC<EmployerLayoutProps> = ({ children }): JSX.Element => {
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  // Public routes that don't need the B2B header
  const publicRoutes = [
    "/signin", 
    "/client-login", 
    "/login-client", 
    "/verify-mobile", 
    "/404",
    "/",
    "login-client"
  ];
  
  const isPublicRoute = publicRoutes.includes(location.pathname);
  
  return (
    <div>
      {/* Show B2BHeader for employer routes, but hide on mobile */}
      {!isPublicRoute && !isMobile && <B2BHeader />}
      {children}
    </div>
  );
};

export default EmployerLayout;
